<sof-spinner-icon size="4x" class="text-white"></sof-spinner-icon>

